import Vue from "vue";

import "@/services";
import { ENDPOINTS } from "@/services/Endpoints.js";
import {
  mdiArrowUp,
  mdiEye,
  mdiEyeOff,
  mdiCalendar,
  mdiClock,
  mdiPencil,
  mdiCheck,
  mdiCloseCircle,
  mdiPlus,
  mdiImage,
  mdiFaceMan,
  mdiCameraAccount,
  mdiCloseCircleOutline,
  mdiFlagVariant,
  mdiUpload,
  mdiDownload,
  mdiCameraFlip,
  mdiAccountCircle,
  mdiCog,
  mdiContentCopy,
  mdiArrowLeftBold,
  mdiCart,
  mdiWeatherSunny,
  mdiWeatherNight,
  mdiChevronUp,
  mdiUpdate,
  mdiArrowLeft,
  mdiMagnify,
  mdiFileDocument,
  mdiStore,
  mdiCellphoneText,
  mdiQrcode,
  mdiHome,
  mdiPlusMinusVariant,
} from "@mdi/js";

Vue.prototype.$config = new Vue({
  data() {
    return {
      ENDPOINTS: ENDPOINTS,
      user_type: "admin",
      modalAlertInteresse: false,
      modalAlertSucesso: false,
      modalConfirm: false,
      confirmDialog: false,
      icons: {
        arrowUp: mdiArrowUp,
        view: mdiEye,
        viewOff: mdiEyeOff,
        calendar: mdiCalendar,
        clock: mdiClock,
        pencil: mdiPencil,
        check: mdiCheck,
        plus: mdiPlus,
        closeCircle: mdiCloseCircle,
        image: mdiImage,
        faceman: mdiFaceMan,
        camera: mdiCameraAccount,
        cameraFlip: mdiCameraFlip,
        clear: mdiCloseCircleOutline,
        flag: mdiFlagVariant,
        upload: mdiUpload,
        download: mdiDownload,
        accountCircle: mdiAccountCircle,
        configIcon: mdiCog,
        copy: mdiContentCopy,
        backButton: mdiArrowLeftBold,
        cart: mdiCart,
        light: mdiWeatherSunny,
        dark: mdiWeatherNight,
        up: mdiChevronUp,
        update: mdiUpdate,
        back: mdiArrowLeft,
        search: mdiMagnify,
        document: mdiFileDocument,
        store: mdiStore,
        cellPhone: mdiCellphoneText,
        qrCode: mdiQrcode,
        home: mdiHome,
        quantity: mdiPlusMinusVariant,
      },
      //
      dados: {
        successColor: "#07bc0c",
        alertColor: "#f5a623",
        errorColor: "#c93720",
        corterciaria: "#353535",
        corinputs: "#353535",
        primary: "#2d1a4c",
        secondary: "#7513BF",
      },
      snackbar: {
        show: false,
        text: "",
        color: "",
        time: 4000,
      },
      width: 1024,
      conteudo: [],
      faq: [],
      paises: [],
      loading_paises: false,
      estados: [],
      loading_estados: false,
      cidades: [],
      loading_cidades: false,
      bancos: [],
      traducao_item: "",
      newsletter: [
        {
          text: "SIM",
          value: 1,
        },
        {
          text: "NÃO",
          value: 0,
        },
      ],
      bloqueado: [
        {
          text: "SIM",
          value: 1,
        },
        {
          text: "NÃO",
          value: 0,
        },
      ],
      status: [
        {
          text: "ATIVO",
          value: "ATIVO",
        },
        {
          text: "INATIVO",
          value: "INATIVO",
        },
      ],
      debug: false,
      site_key_recaptcha: process.env.VUE_APP_RECAPTCHA_KEY,
    };
  },
  computed: {
    themeEnvironment() {
      switch (process.env.NODE_ENV) {
        case "development":
          return {
            primary: "#572C88",
            base: "#e9e8ed",
            secondary: "#e9e8ed",
            tertiary: "#2d1a4c",
            modal: "#e9e8ed",
            fourth: "#572C88",
          };
        case "homolog":
          return {
            primary: "#96E072",
            base: "#e9e8ed",
            secondary: "#e9e8ed",
            tertiary: "#3DA35D",
            modal: "#e9e8ed",
            fourth: "#572C88",
          };
        case "staging":
          return {
            primary: "#1F487E",
            base: "#e9e8ed",
            secondary: "#e9e8ed",
            tertiary: "#1D3461",
            modal: "#e9e8ed",
            fourth: "#572C88",
          };
        case "production":
          return {
            primary: "#b46cfc",
            base: "#e9e8ed",
            secondary: "#e9e8ed",
            tertiary: "#2d1a4c",
            modal: "#e9e8ed",
            fourth: "#572C88",
          };
        default:
          return {
            primary: "#b46cfc",
            base: "#e9e8ed",
            secondary: "#e9e8ed",
            tertiary: "#2d1a4c",
            modal: "#e9e8ed",
            fourth: "#572C88",
          };
      }
    },
    homologEnviroment() {
      if (process.env.NODE_ENV == "development") return true;
      return false;
    },
  },
  methods: {
    isAdmin() {
      if (this.$axios.getLocal("oe_user_info")?.data?.user_type === "admin")
        return true;
      return false;
    },
    removeCache() {
      if (
        this.$axios.getLocal("v") &&
        process.env.VUE_APP_VERSION &&
        process.env.VUE_APP_VERSION != this.$axios.getLocal("v").data
      ) {
        caches.keys().then(cacheNames => {
          cacheNames.forEach(cacheName => {
            caches.delete(cacheName);
          });
        });
        console.warn("removendo o cache de arquivos!");
        return;
      }
      this.$axios.setLocal("v", process.env.VUE_APP_VERSION);
    },
    alert(msn, color, time = 4000) {
      this.snackbar.text = msn;
      this.snackbar.show = true;
      this.snackbar.color = color;
      this.snackbar.time = time;
    },
    getPaises() {
      const self = this;
      this.loading_paises = true;
      setTimeout(() => {
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
          if (this.readyState == 4 && this.status == 200) {
            self.paises = JSON.parse(this.responseText);
          }
        };
        xhttp.open(
          "GET",
          "https://api.eleventickets.com/BuscaEnderecos/paises/?lang=pt",
          true
        );
        this.loading_paises = false;
        xhttp.send();
      }, 1000);
    },
    getEstados(idpais) {
      const self = this;
      this.loading_estados = true;
      setTimeout(() => {
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
          if (this.readyState == 4 && this.status == 200) {
            self.estados = JSON.parse(this.responseText);
            self.cidades = "";
          }
        };
        xhttp.open(
          "GET",
          `https://api.eleventickets.com/BuscaEnderecos/estados/${idpais}?lang=pt`,
          true
        );
        this.loading_estados = false;
        xhttp.send();
      }, 1000);
    },
    getCidades(idestado) {
      const self = this;
      this.loading_cidades = true;
      setTimeout(() => {
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
          if (this.readyState == 4 && this.status == 200) {
            self.cidades = JSON.parse(this.responseText);
            this.loading_cidades = true;
          }
        };
        xhttp.open(
          "GET",
          `https://api.eleventickets.com/BuscaEnderecos/cidades/${idestado}?lang=pt`,
          true
        );
        this.loading_cidades = false;
        xhttp.send();
      }, 1000);
    },
    getBancos() {
      const self = this;
      setTimeout(() => {
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
          if (this.readyState == 4 && this.status == 200) {
            self.bancos = JSON.parse(this.responseText);
          }
        };
        xhttp.open("GET", `https://api.eleventickets.com/bancos`, true);
        xhttp.send();
      }, 1000);
    },
    moedaConverter(v, moeda, lang) {
      var formatter = new Intl.NumberFormat(lang, {
        style: "currency",
        currency: moeda,
        minimumFractionDigits: 2,
      });
      return formatter.format(v);
    },
    // ---- FUNÇÃO QUE CONVERTE DATA PARA FORMATO BRASILEIRO ---- //
    convertDataBR(data) {
      if (data.includes("-")) {
        var datearray = data.split("-");
        if (this.$axios.getLocal("lang").data == "en-US") {
          return datearray[1] + "/" + datearray[2] + "/" + datearray[0];
        }
        return datearray[2] + "/" + datearray[1] + "/" + datearray[0];
      }
      return data;
    },
    convertDataEN(data) {
      if (data.includes("/")) {
        var datearray = data.split("/");
        return datearray[2] + "-" + datearray[1] + "-" + datearray[0];
      }
      return data;
    },
    convertMoney(data) {
      var formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      }).format(Number.parseFloat(data));
      return formatter;
    },
    ModalTraducoes(traducao) {
      this.traducao_item = traducao;
      document.getElementsByClassName("modal-body-traducoes")[0].style.display =
        "flex";
    },
    convertTagString(data) {
      if (!data.includes("<pt_BR>")) {
        return data;
      } else {
        let convertedString = data.substring(
          data.indexOf("<pt_BR>") + 7,
          data.indexOf("</pt_BR>")
        );
        return convertedString;
      }
    },
    /**
     * @function validarEmail
     * @param {String} field
     * @returns RETORNA UM BOOLEANO
     */
    validarEmail(field) {
      // VERIFICA SE TEM O @ E O . ALÉM DO TAMANHO DO DOMINIO
      let usuario = field.substring(0, field.indexOf("@"));
      let dominio = field.substring(field.indexOf("@") + 1, field.length);
      if (
        usuario.length >= 1 &&
        dominio.length >= 3 &&
        usuario.search("@") == -1 &&
        dominio.search("@") == -1 &&
        usuario.search(" ") == -1 &&
        dominio.search(" ") == -1 &&
        dominio.search(".") != -1 &&
        dominio.indexOf(".") >= 1 &&
        dominio.lastIndexOf(".") < dominio.length - 1
      ) {
        return true;
      } else {
        return false;
      }
    },
    /**
     * @function validarCPF
     * @param {String} field
     * @returns RETORNA UM BOOLEANO
     */
    validarCPF(value) {
      if (value === undefined) return;
      const cpf = value.replace(/\D/g, "");
      let result = true;
      if (cpf.toString().length != 11 || /^(\d)\1{10}$/.test(cpf)) {
        return false;
      }
      [9, 10].forEach(item => {
        let soma = 0;
        let res = 0;
        cpf
          .split(/(?=)/)
          .splice(0, item)
          .forEach((e, i) => {
            soma += parseInt(e) * (item + 2 - (i + 1));
          });
        res = soma % 11;
        res = res < 2 ? 0 : 11 - res;
        if (res != cpf.substring(item, item + 1)) {
          result = false;
        }
      });
      return result;
    },
    /**
     * @function validarCNPJ
     * @param {String} field
     * @returns RETORNA TRUE
     */
    validarCNPJ(value) {
      if (value === undefined) return;
      const cnpj = value.replace(/\D/g, "");
      if (cnpj.toString().length != 14 || /^(\d)\1{10}$/.test(cnpj)) {
        return false;
      }
      if (/^0{14}$/.test(cnpj)) {
        return false;
      }
      let tamanho = cnpj.length - 2;
      let numeros = cnpj.substring(0, tamanho);
      let digitos = cnpj.substring(tamanho);
      let soma = 0;
      let pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) {
          pos = 9;
        }
      }
      let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado != digitos.charAt(0)) {
        return false;
      }
      tamanho = tamanho + 1;
      numeros = cnpj.substring(0, tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) {
          pos = 9;
        }
      }
      resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado != digitos.charAt(1)) {
        return false;
      }
      return true;
    },
  },
});

export default Vue.prototype.$config;

// Vue.prototype.$config.getPaises();
// Vue.prototype.$config.getEstados('9e1bf96ca2754ee6596f26fd6e6b5cc2');
